import {css} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import * as BenchlingUtil from 'BenchlingUtil';
import DevToolsIcon from 'dev/DevToolsIcon';
import {makeNavbarBackgroundStyles} from 'nav/navbar/NavBarColor';
import {ElementMouseEvent} from 'util/Types';

import HomeIcon from './HomeIcon';
import {navBarContentsStyles} from './NavBarContents';

interface SettingsNavBarContentsProps {
  onClickHome: (e: ElementMouseEvent) => void;
}

export default function SettingsNavBarContents(props: SettingsNavBarContentsProps): JSX.Element {
  return (
    <div
      style={makeNavbarBackgroundStyles(false)}
      className={classNames(
        css(navBarContentsStyles.navbar, window.impersonating && navBarContentsStyles.impersonating),
        'js-navTour-nav'
      )}
    >
      <HomeIcon
        icon="benchling"
        isActive={false}
        onHomeIconClick={(e) => {
          BenchlingUtil.navigate(e, '/editor');
          props.onClickHome(e);
        }}
      />
      {window.debug && <DevToolsIcon />}
    </div>
  );
}
